import React from "react";

const NotFound = () => {
  window.location.pathname = "/";
  return <div>NotFound</div>;
};

export default NotFound;
